import { ICodeExecutor } from '../../../interfaces/icode-executor';
import { isPromiseAlike } from 'q';
import { TaskInfo } from '../../../interfaces/task-info';
import { IO2Cloud } from '../../../interfaces/io2-cloud';

export class CompiledTypescriptCodeExecutor implements ICodeExecutor {
    public async executeCode(task: TaskInfo, cloud: IO2Cloud): Promise<any> {
        if (!(task.actionToInvoke && task.actionToInvoke.length > 0)) {
            throw new Error(`task.actionToInvoke should specify the fully qualified name of the function to invoke`);
        }
        const codeStr =
            `(function() {
                var exports = {};
                ${task.codeLocation}
                return ${task.actionToInvoke};
            })()`;
        const action = eval(codeStr);
        const resultsOrFuture = action.apply(cloud, [...task.args]);
        let results = null;
        if (resultsOrFuture) {
            if (isPromiseAlike(resultsOrFuture)) {
                results = await resultsOrFuture;
            } else {
                results = resultsOrFuture;
            }
        }
        return results;
    }

    public dispose(): Promise<void> {
        return Promise.resolve();
    }
}
